import fillFormFields from './fill-form-fields';
import retrieveContactData from './retrieve-contact-data';
const queryString = require("query-string");

(window.onpopstate = function () {
    let cookieKey, cookieSubkey, pulseField;

    //console.log(window.pulseCookiesMutation);

    if (window.pulseCookiesMutation === undefined) {
        return;
    }

    let validParams = {};

    let cookiesParams = document.cookie.split(';').reduce((cookies, cookie) => {
        const [ name, value ] = cookie.split('=').map(c => c.trim());
        return { ...cookies, [name]: value };
    }, {});

    Object.entries(window.pulseCookiesMutation).forEach(cookieMutation => {
        [cookieKey, pulseField] = cookieMutation;
        [cookieKey, cookieSubkey] = cookieKey.split(".");

        console.log("-mutation: ", cookieKey, pulseField);

        if (cookiesParams[cookieKey] !== undefined) {

            console.log("--key: ", cookieKey, "subkey: ", cookieSubkey);

            let cookieValue = cookiesParams[cookieKey];

            console.log("---cookieValue: ", cookieValue, 'cookiesParams: ', cookiesParams);

            if (cookieValue.substr(0, 4).toLowerCase() === 'http'){
                cookieValue = new URL(decodeURIComponent(cookieValue)).href;
                console.log("---cookieValue DECODED URL: ", cookieValue);
            }

            if (cookieSubkey !== undefined && isValidURL(cookieValue)){
                console.log("----isValidURL: ", cookieValue);

                let url = new URL(decodeURIComponent(cookieValue));
                let urlParams = queryString.parse(url.search, {arrayFormat: "index"});

                console.log("----separated", urlParams);

                if (urlParams[cookieSubkey] !== undefined) {
                    validParams[pulseField] = urlParams[cookieSubkey];
                }

                console.log("----after: ", validParams);
            }else{
                console.log("----not URL: ", cookieValue);

                validParams[pulseField] = cookieValue;
            }
        }
    });

    console.log('theCookies', validParams, window.pulseCookiesMutation);

    fillFormFields(validParams);
    retrieveContactData(validParams);

    function isValidURL(string) {
        var res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
        return (res !== null)
    }
})();


// WEBPACK FOOTER //
// ./app/Modules/FormBuilder/resources/assets/js/multistep-form-cookies.js